import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {GeneralDragAndDropComponent} from '../../General/g-drag-and-drop';
import {patternSymbolsImages} from '../symbols-mockup';

@Component({
  selector: 'app-complete-pattern-content',
  templateUrl: './complete-pattern-content.component.html',
  styleUrls: ['./complete-pattern-content.component.css']
})
export class CompletePatternContentComponent extends GeneralDragAndDropComponent implements OnChanges {

  @Input() counter: number;
  @Input() level: number;
  @Input() isCompleteEndExercise: boolean;
  @Input() pattern: number[];
  @Output() isCorrectChange = new EventEmitter<boolean>();
  @Output() finishedExerciseChange = new EventEmitter<boolean>();

  patternSequence: number[];
  missingSymbolIndexes: number[];
  symbols: number[];
  currentDropIndex: number;
  symbolsToInsertCounter: number;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.level && changes.pattern === undefined) {
      this.pattern = [];
      this.generateNextExercise();
    } else if (changes.level || changes.counter
      || (changes.pattern !== undefined && changes.pattern.currentValue !== changes.pattern.previousValue)
      || (changes.isCompleteEndExercise !== undefined
        && changes.isCompleteEndExercise.currentValue !== changes.isCompleteEndExercise.previousValue)) {
      console.log(changes);
      this.generateNextExercise();
    }
  }

  initValues() {
    super.initValues();
    this.patternSequence = [];
    this.missingSymbolIndexes = [];
    this.currentDropIndex = -1;
    this.symbolsToInsertCounter = 0;
  }

  checkSolution() {
    if (this.patternSequence[this.currentDropIndex] === this.pattern[this.currentDropIndex % this.pattern.length]) {
      this.symbolsToInsertCounter --;
      this.currentDropIndex = -1;
      this.isCorrectChange.emit(true);
    } else {
      this.patternSequence[this.currentDropIndex] = -1;
      this.currentDropIndex = -1;
      this.isCorrectChange.emit(false);
    }

    if (this.symbolsToInsertCounter === 0) {
      this.pattern = [];
      this.finishedExerciseChange.emit(true);
    }
  }

  generateNextExercise() {
    this.initValues();

    if (this.pattern === undefined || this.pattern.length === 0) {
      // the length of a pattern which is duplicated to create a sequence of this pattern
      const patternLength = this.getPatternLength();
      this.pattern = this.generatePattern(patternLength);
    }
    // how often the pattern will be repeated in the sequence
    const sequenceLength = this.getSequenceLength();
    this. patternSequence = this.generatePatternSequence(this.pattern, sequenceLength);
    console.log(this.patternSequence);

    if (this.isCompleteEndExercise) {
      this.generateCompleteEndExercise();
    } else {
      this.generateRandomCompleteExercise();
    }

    this.setAllDragElementIds();
  }

  getPatternLength() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 2);
    } else if (this.level === 2) {
      return Math.floor((Math.random() * 2) + 3);
    } else {
      return Math.floor((Math.random() * 3) + 4);
    }
  }

  getSequenceLength() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 2);
    } else {
      return Math.floor((Math.random() * 3) + 2);
    }
  }

  generatePattern(length: number) {
    const pattern = [];
    let countDifferentSymbols = 0;

    for (let i = 0; i < length; i++) {
      const randomSymbol = Math.floor((Math.random() * 15));
      if (pattern.indexOf(randomSymbol) === -1) {
        countDifferentSymbols++;
      }
      pattern.push(randomSymbol);
    }

    // To avoid that the pattern is only one symbol.
    if (countDifferentSymbols === 1) {
      let randomSymbol = Math.floor((Math.random() * 15));
      while (pattern.indexOf(randomSymbol) !== -1) {
        randomSymbol = Math.floor((Math.random() * 15));
      }
      pattern[length - 1] = randomSymbol;
    }

    return pattern;
  }

  generatePatternSequence(pattern: number[], length: number) {
    const sequence = [];
    for (let i = 0; i < length; i++) {
      for (let j = 0; j < pattern.length; j++) {
        sequence.push(pattern[j]);
      }
    }

    return sequence;
  }

  generateCompleteEndExercise() {
    // the length of the last pattern, which has to be completed by the user:
    const lastPatternLength = Math.floor(Math.random() * (this.pattern.length - 1));

    for (let i = 0; i < lastPatternLength; i++) {
      this.patternSequence.push(this.pattern[i]);
    }

    if (this.level === 1) {
      this.symbolsToInsertCounter = 1;
      this.patternSequence.push(-1);
      this.missingSymbolIndexes.push(this.patternSequence.length - 1);
    } else {
      this.symbolsToInsertCounter = 2;
      this.patternSequence.push(-1);
      this.missingSymbolIndexes.push(this.patternSequence.length - 1);
      this.patternSequence.push(-1);
      this.missingSymbolIndexes.push(this.patternSequence.length - 1);
    }

    console.log(this.patternSequence);
  }

  generateRandomCompleteExercise() {
    if (this.patternSequence.length / this.pattern.length === 2) {
      for (let i = 0; i < this.pattern.length; i++) {
        this.patternSequence.push(this.pattern[i]);
      }
    }

    const lastPatternLength = Math.floor(Math.random() * (this.pattern.length - 1));
    const countErasePlace: number[] = [];
    for (let i = 0; i < this.pattern.length; i++) {
      if (i < lastPatternLength) {
        this.patternSequence.push(this.pattern[i]);
      }
      countErasePlace.push(0);
    }

    let randomIndex = Math.floor(Math.random() * this.patternSequence.length);
    let counter = 0;
    const maxPossibleErase = Math.floor(this.patternSequence.length / this.pattern.length) - 1;
    if (this.level === 1) {
      this.symbolsToInsertCounter = 1;
      this.patternSequence[randomIndex] = -1;
      this.missingSymbolIndexes.push(randomIndex);
    } else if (this.level === 2) {
      this.symbolsToInsertCounter = 2;
      while (counter < this.symbolsToInsertCounter) {
        if (this.patternSequence[randomIndex] !== -1 && countErasePlace[randomIndex % this.pattern.length] < maxPossibleErase) {
          this.patternSequence[randomIndex] = -1;
          this.missingSymbolIndexes.push(randomIndex);
          countErasePlace[randomIndex % this.pattern.length] ++;
          counter ++;
        }
        randomIndex = Math.floor(Math.random() * this.patternSequence.length);
      }
    } else {
      this.symbolsToInsertCounter = 3;
      while (counter < this.symbolsToInsertCounter) {
        if (this.patternSequence[randomIndex] !== -1 && countErasePlace[randomIndex % this.pattern.length] < maxPossibleErase) {
          this.patternSequence[randomIndex] = -1;
          this.missingSymbolIndexes.push(randomIndex);
          countErasePlace[randomIndex % this.pattern.length] ++;
          counter ++;
        }
        randomIndex = Math.floor(Math.random() * this.patternSequence.length);
      }
    }
  }

  onMouseUp(event) {
    if (this.currentDragElementId !== null) {
      if (this.currentBelowElement !== null) {
        for (let i = 0; i < this.allDragElementIds.length; i++) {
          if (this.currentDragElementId.value === this.allDragElementIds[i].toString()) {
            this.currentDropIndex = parseInt(this.currentBelowElement.id, 10);
            this.patternSequence[parseInt(this.currentBelowElement.id, 10)] = this.symbols[i];
            break;
          }
        }
      }
      this.currentBelowElement = null;

      this.currentDragElementId.ownerElement.style.position = '';
      this.currentDragElementId.ownerElement.style.left = '';
      this.currentDragElementId.ownerElement.style.top = '';
      this.currentDragElementId.ownerElement.style.zIndex = 3;
      this.currentDragElementId.ownerElement.style.width = '';
      this.currentDragElementId = null;

      if (this.currentDropIndex !== -1) {
        this.checkSolution();
      }
    }
  }

  getDragElementMaxSize() {
    return 8;
  }

  setAllDragElementIds() {
    this.symbols = [];
    this.allDragElementIds = [];
    for (let i = 0; i < this.pattern.length; i++) {
      if (this.symbols.indexOf(this.pattern[i]) === -1) {
        this.symbols.push(this.pattern[i]);
      }
    }
    this.symbols.sort((a, b) => a - b);

    for (let i = 0; i < this.symbols.length; i++) {
      this.allDragElementIds.push('symbol_' + this.symbols[i]);
    }
  }

  isFixedSymbol(value: number) {
    return this.missingSymbolIndexes.indexOf(value) === -1;
  }

  getActive(i: number) {
    return this.patternSequence[i] === -1 && this.currentBelowElement !== null && parseInt(this.currentBelowElement.id, 10) === i;
  }

  getHidden(id: number) {
    if (this.currentDragElementId === null) {
      return true;
    }

    return !(this.currentDragElementId.value === this.allDragElementIds[id]);
  }

  getSymbolImage(idx: number) {
    if (idx === -1) {
      return './assets/images/pattern/empty.png';
    }
    return patternSymbolsImages[idx];
  }
}
